import { View } from "binder"
import { EmptyWindowViewModel } from "./emptyWindow-viewModel"

export class EmptyWindowView extends View<EmptyWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-8819F06B-F939-4492-BE31-F5F7A6979BB5"
    }
    loadHtml(): string {
        let element = require('./emptyWindow.html').default;
        let style = require('./emptyWindow.less');
        return element;
    }
    constructor() {
       super();
    }
}
